"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const imurmurhash_1 = tslib_1.__importDefault(require("imurmurhash"));
exports.uniqueSlug = (uniq) => {
    if (uniq) {
        const hash = new imurmurhash_1.default(uniq);
        const returnVal = ('00000000' + hash.result().toString(16)).substr(-8);
        // console.trace(`uniqueSlug:  ${uniq} -> ${returnVal}`);
        return returnVal;
    }
    else {
        return (Math.random().toString(16) + '0000000').substr(2, 8);
    }
};
//# sourceMappingURL=uniqueSlug.js.map